import mixpanel from "mixpanel-browser";

// Public browser tokens, one EU project per build mode. PR previews send nothing.
const tokensByMode: Record<string, string> = {
  production: "1a2fa5fb7c1a0d2f7a2a08e35faad321", // Staff — Prod (4068656)
  development: "d58a2f5101d0b3b6607fb948bd4f122d", // Staff — Dev (4068655)
};

let started = false;

// The staff menu must keep working when Mixpanel fails; log so monitoring sees it.
const reportFailure = (error: unknown) =>
  console.error("Mixpanel failed", error);

const whenStarted = (fn: () => void) => {
  if (!started) return;
  try {
    fn();
  } catch (error) {
    reportFailure(error);
  }
};

/** Staff are anonymous: Mixpanel's own device ID tells devices apart. */
export const startAnalytics = () => {
  const token = tokensByMode[process.env.MODE ?? ""];
  if (!token) return;
  try {
    mixpanel.init(token, {
      api_host: "https://api-eu.mixpanel.com",
      autocapture: false,
      persistence: "localStorage",
      record_sessions_percent: 0,
      track_pageview: false,
    });
    started = true;
  } catch (error) {
    reportFailure(error);
  }
};

/** Properties sent with every later event. */
export const setStaffContext = (properties: Record<string, unknown>) =>
  whenStarted(() => mixpanel.register(properties));

export const trackStaffEvent = (
  name: string,
  properties?: Record<string, unknown>
) => whenStarted(() => mixpanel.track(name, properties));
